export default {
  category_name: 'Geschenkkarte',
};
